<template>
  <div
      class="flex flex-col items-center mx-4 mt-3 px-2"
      id="a4-receipt"
      :class="{
      'dir-ltr': $ctx.receiptLanguage == 'en',
      'dir-rtl': $ctx.receiptLanguage == 'ar'
      }"
      :style="{'font-size': $ctx.getReceiptSize() == 'a5' ? '16px': '14px'}"
  >
    <div class="flex flex-col items-center w-full a4-receipt-page" style="height: 100vh;">
      <!-- header info -->
      <div id="a4-receipt-header" class="flex flex-col w-full">
        <div class="flex mt-4 justify-between items-center w-full">
          <div class="mx-8 mt-3 pb-2">
            <div class="flex items-center gap-2 mb-1">
              <img src="@/assets/icons/receipt/map-marker.svg" width="16" height="16" class="shrink-0" />
              <span>{{ settingsStore.getValue('company_address') }}</span>
            </div>
            <div class="flex items-center gap-2 mb-1">
              <img src="@/assets/icons/receipt/phone.svg" width="16" height="16" class="shrink-0" />
              <span dir="ltr">{{ settingsStore.getValue('company_phone1') + (settingsStore.getValue('company_phone2') ? ` - ${settingsStore.getValue('company_phone2')}` : '') }}</span>
            </div>
            <div class="flex items-center gap-6">
              <div v-if="settingsStore.getValue('company_email')" class="flex items-center gap-2">
                <img src="@/assets/icons/receipt/email.svg" width="16" height="16" class="shrink-0" />
                <span>{{ settingsStore.getValue('company_email') }}</span>
              </div>
              <div v-if="settingsStore.getValue('company_website')" class="flex items-center gap-2">
                <img src="@/assets/icons/receipt/web.svg" width="16" height="16" class="shrink-0" />
                <span>{{ settingsStore.getValue('company_website') }}</span>
              </div>
            </div>
          </div>

          <div class="mx-8">
            <img
                :src="settingsStore.getValue('receipt_logo') ? settingsStore.storagePath + '/' + settingsStore.getValue('receipt_logo'): '/images/logo.svg'"
                :width="settingsStore.getValue('receipt_logo_width')"
                :style="{'margin-top': settingsStore.getValue('receipt_logo_top_margin') + 'px', 'margin-right': settingsStore.getValue('receipt_logo_right_margin') + 'px'}"
                alt=""/>
          </div>
        </div>

        <div class="flex flex-col w-full items-center">
          <div class="w-11/12 h-[3px] rounded-full"
              :style="{background: `linear-gradient(to right, transparent, ${settingsStore.getValue('receipt_branding_color') || '#585954'}, transparent)`}"></div>
        </div>
      </div>

      <div id="a4-receipt-body" class="w-full">
        <!-- title -->
        <div class="flex flex-col w-full mt-2 items-center">
          <h2 class="bg-gray-200 rounded py-1 px-16 font-bold capitalize">
            {{ isQuote ? receiptTranslate("Quote", "receipt.quoteInvoice") : receiptTranslate("Sales Invoice", "receipt.salesInvoice") }}
          </h2>
        </div>

        <!-- order type info and barcode -->
        <div class="flex w-full justify-around items-start">
          <div>
            <table class="w-full" :class="{ 'ar-receipt': $ctx.receiptLanguage == 'ar' }">
              <!--              <tr>-->
              <!--                <td>-->
              <!--                  <p>{{ receiptTranslate("Order Type", "receipt.orderType") }}</p>-->
              <!--                </td>-->
              <!--                <td>-->
              <!--                  <p class="font-bold mx-5">-->
              <!--                    <span v-if="order.orderType == 'direct'">{{-->
              <!--                      receiptTranslate("Direct", "receipt.orderTypes.direct")-->
              <!--                    }}</span>-->
              <!--                    <span v-if="order.orderType == 'pick_up'">{{-->
              <!--                      receiptTranslate("Pick Up", "receipt.orderTypes.pickup")-->
              <!--                    }}</span>-->
              <!--                    <span v-if="order.orderType == 'delivery'">{{-->
              <!--                      receiptTranslate("Delivery", "receipt.orderTypes.delivery")-->
              <!--                    }}</span>-->
              <!--                  </p>-->
              <!--                </td>-->
              <!--              </tr>-->
              <!--              <tr>-->
              <!--                <td>-->
              <!--                  <p>{{ receiptTranslate("Payment Terms", "receipt.paymentTerms") }}</p>-->
              <!--                </td>-->
              <!--                <td>-->
              <!--                  <p class="font-bold mx-5">-->
              <!--                    <span v-if="order.invoice.paymentType == 'direct'">{{-->
              <!--                        receiptTranslate("Full", "receipt.invoiceTypes.full")-->
              <!--                      }}</span>-->
              <!--                    <span v-if="order.invoice.paymentType == 'credit_sale'">{{-->
              <!--                        receiptTranslate("On Account", "receipt.invoiceTypes.credit")-->
              <!--                      }}</span>-->
              <!--                    <span v-if="order.invoice.paymentType == 'layaway'">{{-->
              <!--                        receiptTranslate("Layaway", "receipt.invoiceTypes.layaway")-->
              <!--                      }}</span>-->
              <!--                    <span v-if="order.invoice.paymentType == 'cash_on_delivery'">{{-->
              <!--                        receiptTranslate("Cash on Delivery", "receipt.invoiceTypes.cashOnDelivery")-->
              <!--                      }}</span>-->
              <!--                  </p>-->
              <!--                </td>-->
              <!--              </tr>-->
              <tr>
                <td>
                  <p>
                    {{ receiptTranslate("Customer", "receipt.customer") }}
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5">
                    {{
                      order.invoice.customer?.contactDisplayName
                          ? `${order.invoice.customer?.contactDisplayName} ${
                              order.invoice.customer?.businessName
                                  ? " - " + order.invoice.customer?.businessName
                                  : ""
                          }`
                          : receiptTranslate(
                              "Cash Customer",
                              "receipt.cashCustomer"
                          )
                    }}
                  </p>
                </td>
              </tr>
              <tr v-if="order.invoice?.billDueDate">
                <td>
                  <p>{{ receiptTranslate("Due on", "receipt.dueOn") }}</p>
                </td>
                <td>
                  <p class="font-bold mx-5">{{ formatDate(order.invoice.billDueDate, 'DD/MM/YYYY') }}</p>
                </td>
              </tr>
              <tr v-if="order.invoice.customer && order.invoice.customer.phone && settingsStore.getValue('show_customer_phone_in_receipt') == 'true'">
                <td>
                  <p>
                    {{ receiptTranslate("Phone", "receipt.phone") }}
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5">
                    {{
                      order.invoice.customer.phone + (order.invoice.customer.phone2 ? ` - ${order.invoice.customer.phone2}`: '')
                    }}
                  </p>
                </td>
              </tr>
              <tr v-if="order.invoice.customer && order.invoice.customer.streetAddress && settingsStore.getValue('show_customer_address_in_receipt') == 'true'">
                <td>
                  <p>
                    {{ receiptTranslate("Address", "receipt.address") }}
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5">
                    {{
                      order.invoice.customer.streetAddress
                    }}
                  </p>
                </td>
              </tr>
              <tr v-if="isQuote">
                <td>
                  <p>{{ receiptTranslate("Payment Terms", "receipt.paymentTerms") }}</p>
                </td>
                <td>
                  <p class="font-bold mx-5">
                    <span v-if="order.invoice.paymentType == 'direct'">{{ receiptTranslate("Full", "receipt.invoiceTypes.full") }}</span>
                    <span v-if="order.invoice.paymentType == 'credit_sale'">{{ receiptTranslate("On Account", "receipt.invoiceTypes.credit") }}</span>
                    <span v-if="order.invoice.paymentType == 'layaway'">{{ receiptTranslate("Layaway", "receipt.invoiceTypes.layaway") }}</span>
                    <span v-if="order.invoice.paymentType == 'cash_on_delivery'">{{ receiptTranslate("Cash on Delivery", "receipt.invoiceTypes.cashOnDelivery") }}</span>
                  </p>
                </td>
              </tr>
              <tr v-if="isQuote && order.validUntil">
                <td>
                  <p>{{ receiptTranslate("Valid Until", "receipt.validUntil") }}</p>
                </td>
                <td>
                  <p class="font-bold mx-5">{{ formatDate(order.validUntil, 'DD/MM/YYYY') }}</p>
                </td>
              </tr>
              <!--              <tr>-->
              <!--                <td>-->
              <!--                  <p>-->
              <!--                    {{ receiptTranslate("Location", "receipt.location") }}-->
              <!--                  </p>-->
              <!--                </td>-->
              <!--                <td>-->
              <!--                  <p v-if="$ctx.receiptLanguage == 'en'" class="font-bold mx-5">-->
              <!--                    {{ order.location?.enName || "" }}-->
              <!--                  </p>-->
              <!--                  <p v-if="$ctx.receiptLanguage == 'ar'" class="font-bold mx-5">-->
              <!--                    {{ order.location?.arName || "" }}-->
              <!--                  </p>-->
              <!--                </td>-->
              <!--              </tr>-->
              <!--              <tr>-->
              <!--                <td>-->
              <!--                  <p>-->
              <!--                    {{ receiptTranslate("Order No", "receipt.orderNo") }}-->
              <!--                  </p>-->
              <!--                </td>-->
              <!--                <td>-->
              <!--                  <p class="font-bold mx-5">{{ order.externalID }}</p>-->
              <!--                </td>-->
              <!--              </tr>-->
              <tr v-if="!isQuote && settingsStore.getValue('hide_cashier_name_in_receipt') != 'true'">
                <td>
                  <p>
                    {{ receiptTranslate("Cashier", "receipt.cashier") }}
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5">{{ order.user?.fullName }}</p>
                </td>
              </tr>
              <tr v-if="isQuote">
                <td>
                  <p>{{ receiptTranslate("Quoted By", "receipt.quotedBy") }}</p>
                </td>
                <td>
                  <p class="font-bold mx-5">{{ order.user?.fullName }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    {{ receiptTranslate("Date & Time", "receipt.dateAndTime") }}
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5" dir="ltr">
                    {{ parseFormat(order.createdAt) }}
                  </p>
                </td>
              </tr> 
              <tr v-if="order.invoice.carrier?.name && settingsStore.getValue('show_carrier_info_on_receipt') == 'true'">
                <td>
                  <p class="flex gap-2 items-center">
                    {{ receiptTranslate("Carrier", "receipt.carrier") }}
                    <Icon icon="material-symbols:delivery-truck-speed-outline" :height="24"></Icon>
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5">
                    {{ order.invoice.carrier?.name }} {{ `${order.invoice.carrier?.phone ? '- ' + order.invoice.carrier?.phone: ''}` }}
                  </p>
                </td>
              </tr>
              <tr v-if="order.invoice.notes">
                <td>
                  <p>
                    {{ receiptTranslate("Order Notes", "receipt.orderNotes") }}
                  </p>
                </td>
                <td>
                  <p class="font-bold mx-5">
                    {{ order.invoice.notes }}
                  </p>
                </td>
              </tr>
            </table>
          </div>

          <div class="flex flex-col items-center">
            <div>
              <PaymentStatusReceiptRenderer v-if="settingsStore.getValue('show_receipt_payment_status_stamp') == 'true'" :data="order"></PaymentStatusReceiptRenderer>
              <svg id="barcode"></svg>
              <div class="flex items-center justify-center">
                <span class="font-bold mx-5 text-xl">{{
                    barcodeText
                  }}</span>
              </div>
            </div>
            <div
                v-if="order?.invoice.pouchID"
                class="flex flex-col w-full items-center"
            >
              <h2 class="bg-gray-200 rounded py-1 px-2 flex">
                <span>{{ receiptTranslate("Pouch #", "receipt.pouch") }}</span>
                <span class="flex justify-end custom-bold mx-2">
                  {{ order?.invoice.pouchID }}
                </span>
              </h2>
            </div>
          </div>
        </div>

        <!-- items -->
        <div class="w-full px-5 my-1">
          <table class="receipt-table w-full" :class="{ 'ar-receipt': $ctx.receiptLanguage == 'ar' }">
            <thead>
            <tr class="">
              <th>
                {{ receiptTranslate("Item Name", "receipt.itemName") }}
              </th>
              <th>{{ receiptTranslate("Qty", "receipt.qty") }}</th>
              <th>{{ receiptTranslate("Price", "receipt.price") }}</th>
              <th>
                {{ receiptTranslate("Total", "receipt.total") }}
              </th>
            </tr>
            </thead>

            <tbody v-if="order.orderItems">
            <tr
                v-for="(oi, i) in returnedOrderItems(order)"
                :key="i"
                class="text-red-500"
                :class="{ 'receipt-row-border': !oi.item.isSerialized}"
            >
              <td class="reciept-cell line-through" :class="{ 'sp-item-highlight': hasSpItemTag(oi)}" style="line-height: 15px;">
                <div>
                  <span>{{ oi.item.receiptName ? oi.item.receiptName: oi.item.name }}</span>
                  <span v-if="oi.packInfo?.packID" class="mx-1">{{
                      ` - ${getPackName(oi)}, ${oi.packInfo.packQuantity} ${t('pcs')}`
                    }}</span>
                </div>
                <div v-if="oi.item.isSerialized && settingsStore.getValue('hide_serial_number_in_receipts') != 'true'" class="flex gap-2 flex-wrap">
                  <small v-for="ois in oi.orderItemSerials"
                         class="bg-gray-200 rounded-md px-1">{{
                      ois.itemSerial?.number
                    }}</small>
                </div>
                <small>{{ oi.notes }}</small>
              </td>

              <td>{{ oi.returnedQuantity }}</td>
              <td class="line-through">
                {{ formatDinero(oi.soldAtPriceDinero).replace("IQD", "") }}
              </td>
              <td class="line-through">{{ formatMoney(oi.itemSalePriceAmount * oi.returnedQuantity, "IQD").replace("IQD", "") }}</td>
            </tr>


            <tr
                v-for="(oi, i) in notReturnedOrderItems(order)"
                :key="i"
                class=""
                :class="{ 'receipt-row-border': !oi.item.isSerialized}"
            >
              <td class="reciept-cell" :class="{ 'sp-item-highlight': hasSpItemTag(oi)}" style="line-height: 15px;">
                <div>
                  <span>{{ oi.item.receiptName ? oi.item.receiptName: oi.item.name }}</span>
                  <span v-if="oi.packInfo?.packID" class="mx-1">{{
                      ` - ${getPackName(oi)}, ${oi.packInfo.packQuantity} ${t('pcs')}`
                    }}</span>
                </div>
                <div v-if="oi.extraProperties?.batchNumber">
                  <span class="my-1 bg-gray-200 rounded-md px-1">{{ oi.extraProperties?.batchNumber }} - {{ oi.extraProperties?.expiryDate ? formatDate(oi.extraProperties?.expiryDate, 'DD-MM-YYYY') : '' }}</span>
                </div>
                <div v-if="oi.item.isSerialized && settingsStore.getValue('hide_serial_number_in_receipts') != 'true'" class="flex gap-2 flex-wrap">
                  <small v-for="ois in oi.orderItemSerials"
                         class="bg-gray-200 rounded-md px-1">{{
                      ois.itemSerial?.number
                    }}</small>
                </div>
                <small>{{ oi.notes }}</small>
              </td>

              <td>{{ oi.quantity - oi.returnedQuantity }}</td>
              <td>
                <!-- Case 1: Item has discount - show (sold-at + discount) as strikethrough -->
                <div v-if="oi.itemDiscountTotal && oi.itemDiscountTotal > 0" style="line-height: 15px;">
                  <div class="line-through">{{ formatMoney(oi.itemSalePriceAmount + oi.itemDiscountTotal, "IQD").replace("IQD", "") }}</div>
                  <div>{{ formatDinero(oi.soldAtPriceDinero).replace("IQD", "") }}</div>
                </div>
                <!-- Case 2: No discount but has dynamic pricing - show standard price as strikethrough -->
                <div v-else-if="oi.itemSalePriceAmount !== oi.item.salePriceAmount && (oi.itemSalePriceAmount < oi.item.salePriceAmount)" style="line-height: 15px;">
                  <div class="line-through">{{ formatMoney(oi.item.salePriceAmount, "IQD").replace("IQD", "") }}</div>
                  <div>{{ formatDinero(oi.soldAtPriceDinero).replace("IQD", "") }}</div>
                </div>
                <!-- Case 3: No discount and no dynamic pricing - show normal price -->
                <div v-else>
                  <div class="line-through" v-if="oi.soldAtPriceAmount < oi.item.salePriceAmount ">{{ formatMoney(oi.item.salePriceAmount, "IQD").replace("IQD", "") }}</div>
                  <div>{{ formatDinero(oi.soldAtPriceDinero).replace("IQD", "") }}</div>
                </div>
              </td>
              <td>{{ formatMoney(oi.soldAtPriceAmount * (oi.quantity - oi.returnedQuantity), "IQD").replace("IQD", "") }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- payment info -->
        <div class=" flex flex-col w-full items-end">
          <div class="flex-col w-5/12 mr-10">
            <div class="px-4 w-full mt-2">
              <table
                  class="payment-table"
                  :class="{ 'ar-receipt': $ctx.receiptLanguage == 'ar' }"
              >
                <tr v-if="order.invoice?.totalDiscountAmount || calculateTotalItemDiscounts() > 0">
                  <td>
                    <p class="p-0">
                      {{
                        receiptTranslate(
                            "Total Before Discounts",
                            "receipt.totalBeforeDiscounts"
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      {{
                        formatMoney(calculateTotalBeforeDiscounts(), "IQD")
                      }}
                    </p>
                  </td>
                </tr>

                <tr v-if="order.invoice?.totalDiscountAmount || calculateTotalItemDiscounts() > 0">
                  <td>
                    <p class="p-0">
                      {{
                        receiptTranslate(
                            "Total Discount",
                            "receipt.totalDiscount"
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      -{{ formatMoney((order.invoice?.totalDiscountAmount || 0) + calculateTotalItemDiscounts(), "IQD") }}
                    </p>
                  </td>
                </tr>

                <tr>
                  <td>
                    <p class="p-0">
                      {{
                        receiptTranslate("Customer Total", "receipt.customerDue")
                      }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      {{ formatDinero(order.invoice?.totalDueDinero) }}
                    </p>
                  </td>
                </tr>

                <tr v-if="order.invoice?.shippingFeeAmount">
                  <td class="flex items-center gap-1">
                    <p class="p-0">
                      {{
                        receiptTranslate(
                            "Shipping",
                            "receipt.totalShipping"
                        )
                      }}
                    </p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em"
                         height="1em" viewBox="0 0 640 512">
                      <path fill="currentColor"
                            d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16M160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48m320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48m80-208H416V144h44.1l99.9 99.9z"></path>
                    </svg>
                  </td>
                  <td>
                    <p class="text-right">
                      {{ formatDinero(order.invoice?.shippingFeeDinero) }}
                    </p>
                  </td>
                </tr>

                <tr v-if="order.invoice?.totalDueAmount > 0 && order.invoice?.insuranceTotalDueAmount">
                  <td>
                    <p class="p-0">
                      {{ receiptTranslate("Total Due", "receipt.totalDue") }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      {{
                        formatMoney(order.invoice?.totalDueAmount + order.invoice?.insuranceTotalDueAmount, "IQD")
                      }}
                    </p>
                  </td>
                </tr>

                <tr v-if="order.invoice?.insuranceID">
                  <td class="flex items-center gap-1">
                    <p class="p-0">
                      {{
                        receiptTranslate(
                            "Insurance",
                            "receipt.insurance"
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      {{ formatDinero(order.invoice?.insuranceTotalDueDinero) }}
                    </p>
                  </td>
                </tr>

                <tr v-if="!orderHasPack(order)">
                  <td>
                    <p class="p-0">
                      {{
                        isQuote
                            ? receiptTranslate("Total Items", "receipt.totalItems")
                            : receiptTranslate("Total Items Sold", "receipt.totalItemsSold")
                      }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      {{ calculateTotalItemsSold() }}
                    </p>
                  </td>
                </tr>
                <template v-else>
                  <tr>
                    <td>
                      <p class="p-0">
                        {{
                          receiptTranslate(
                              "Total Packs Sold",
                              "receipt.totalPacksSold"
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p class="text-right">
                        {{ calculateTotalPacksSold(order) }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p class="p-0">
                        {{
                          receiptTranslate(
                              "Total Items Sold",
                              "receipt.totalItemsSold"
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p class="text-right">
                        {{ calculateTotalItemsSoldV2(order) }}
                      </p>
                    </td>
                  </tr>
                  <tr v-if="calculateTotalItemsReturnedV2(order) > 0">
                    <td>
                      <p class="p-0">
                        {{
                          receiptTranslate(
                              "Total Items Returned",
                              "receipt.totalItemsReturned"
                          )
                        }}
                      </p>
                    </td>
                    <td>
                      <p class="text-right">
                        {{ calculateTotalItemsReturnedV2(order) }}
                      </p>
                    </td>
                  </tr>
                </template>
                <tr v-if="!orderHasPack(order) && calculateTotalItemsReturned() > 0">
                  <td>
                    <p class="p-0">
                      {{
                        receiptTranslate(
                            "Total Items Returned",
                            "receipt.totalItemsReturned"
                        )
                      }}
                    </p>
                  </td>
                  <td>
                    <p class="text-right">
                      {{ calculateTotalItemsReturned() }}
                    </p>
                  </td>
                </tr>
              </table>
            </div>

            <div class="w-full p-2"></div>

            <div class="px-4 w-full" v-if="transactions.length">
              <!--              <div style="color: #6e6e6e; padding-left: 2px">-->
              <!--                <h4 class="text-lg">-->
              <!--                  {{-->
              <!--                    receiptTranslate("Transactions Info", "receipt.transactionsInfo")-->
              <!--                  }}-->
              <!--                </h4>-->
              <!--              </div>-->

              <div
                  v-for="customerPayment in transactions"
                  class="mb-2"
                  :key="customerPayment.id"
              >
                <table
                    class="payment-table"
                    :class="{ 'ar-receipt': $ctx.receiptLanguage == 'ar' }"
                    style="border-bottom: 1px solid #e6e6e6"
                >
                  <tr>
                    <td>
                      <p class="p-0">
                        {{
                          receiptTranslate("Payment ID", "receipt.paymentID")
                        }}: {{ customerPayment.externalID }}
                      </p>
                    </td>
                    <td>
                      <p class="text-right" dir="ltr">
                        {{ parseFormat(customerPayment.createdAt) }}
                      </p>
                    </td>
                  </tr>
                </table>

                <table
                    class="payment-table"
                    :class="{ 'ar-receipt': $ctx.receiptLanguage == 'ar' }"
                >
                  <tr
                      v-if="
                      customerPayment.receiptType != 'return' && customerPayment.receiptType != 'refund' &&
                        customerPayment.paymentMethod === 'cash'
                    "
                  >
                    <td>{{ receiptTranslate("Cash", "receipt.cash") }}</td>
                    <td>
                      <p v-if="customerPayment.paidBeforeChangeAmount > 0" class="text-right">
                        {{
                          formatDinero(customerPayment.paidBeforeChangeDinero)
                        }}
                      </p>
                      <p v-else class="text-right">
                        {{ formatDinero(customerPayment.amountDinero) }}
                      </p>
                    </td>
                  </tr>

                  <tr
                      v-if="
                      customerPayment.receiptType != 'return' && customerPayment.receiptType != 'refund' &&
                        customerPayment.paymentMethod === 'credit'
                    "
                  >
                    <td>{{ receiptTranslate("Credit", "receipt.customerCredit") }}</td>
                    <td>
                      <p v-if="customerPayment.paidBeforeChangeAmount > 0" class="text-right">
                        {{
                          formatDinero(customerPayment.paidBeforeChangeDinero)
                        }}
                      </p>
                      <p v-else class="text-right">
                        {{ formatDinero(customerPayment.amountDinero) }}
                      </p>
                    </td>
                  </tr>

                  <tr
                      v-if="
                      customerPayment.receiptType == 'refund' &&
                        (customerPayment.paymentMethod === 'cash' || customerPayment.paymentMethod === 'credit')
                    "
                  >
                    <td v-if="customerPayment.paymentMethod === 'cash'">{{ receiptTranslate("Cash", "receipt.cash") }}</td>
                    <td v-else>{{ receiptTranslate("Credit", "receipt.customerCredit") }}</td>
                    <td>
                      <p class="text-right">
                        ({{ formatDinero(customerPayment.amountDinero)}})
                      </p>
                    </td>
                  </tr>

                  <tr
                      v-if="
                      customerPayment.receiptType == 'return' &&
                        customerPayment.paymentMethod === 'cash'
                    "
                  >
                    <td>{{ receiptTranslate("Cash", "receipt.cash") }}</td>
                    <td>
                      <p class="text-right">
                        ({{ formatDinero(customerPayment.amountDinero)}})
                      </p>
                    </td>
                  </tr>
                  <tr
                      v-if="
                      customerPayment.receiptType == 'return' &&
                        customerPayment.paymentMethod === 'credit'
                    "
                  >
                    <td>{{ receiptTranslate("Credit", "receipt.customerCredit") }}</td>
                    <td>
                      <p class="text-right">
                        ({{ formatDinero(customerPayment.amountDinero)}})
                      </p>
                    </td>
                  </tr>

                  <tr
                      v-if="
                      customerPayment.receiptType != 'return' &&
                        customerPayment.paymentMethod == 'debit-card'
                    "
                  >
                    <td>E-Payment{{ customerPayment.lastFourDigits ? ' (' + customerPayment.lastFourDigits + ')' : '' }}</td>
                    <td>
                      <p class="text-right">
                        {{
                            formatDinero(customerPayment.amountDinero)
                        }}
                      </p>
                    </td>
                  </tr>

                  <tr
                      v-if="customerPayment.multiCurrencyBreakdown?.length === 2 && customerPayment.multiCurrencyBreakdown[1].amount > 0"
                  >
                    <td>
                      {{
                        receiptTranslate("Payment Currencies", "receipt.paymentCurrencies")
                      }}
                    </td>
                    <td>
                      <p
                          class="text-right"
                      >
                        {{ formatMoney(customerPayment.multiCurrencyBreakdown[0].amountBeforeChange, customerPayment.multiCurrencyBreakdown[0].currency) }}
                        +
                        {{ formatMoney(customerPayment.multiCurrencyBreakdown[1].amountBeforeChange, customerPayment.multiCurrencyBreakdown[1].currency) }}
                      </p>
                    </td>
                  </tr>

                  <tr
                      v-if="
                      customerPayment.receiptType != 'return' &&
                        customerPayment.paymentMethod === 'cash' && customerPayment.changeDueAmount > 0
                    "
                  >
                    <td>
                      {{ receiptTranslate("Change Due", "receipt.changeDue") }}
                    </td>
                    <td>
                      <p class="text-right">
                        {{ formatDinero(customerPayment.changeDueDinero) }}
                      </p>
                    </td>
                  </tr>
                  <tr v-if="customerPayment.receiptType != 'return' && customerPayment.balanceDinero.getAmount() > 0">
                    <td>
                      {{ receiptTranslate("Balance", "receipt.balance") }}
                    </td>
                    <td>
                      <p class="text-right">
                        {{ formatDinero(customerPayment.balanceDinero) }}
                      </p>
                    </td>
                  </tr>
                  <tr v-if="customerPayment.receiptType != 'return' && customerPayment.description">
                    <td>
                      {{
                        receiptTranslate(
                            "Payment Notes",
                            "receipt.paymentNotes"
                        )
                      }}
                    </td>
                    <td>
                      <p class="text-right">
                        {{ customerPayment.description }}
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
          id="a4-receipt-footer"
          class="flex flex-col items-center w-full mt-auto"
      >
        <div class="flex flex-col w-full items-end">

          <div v-if="settingsStore.getValue('show_signature_field') == 'true'" class="font-bold flex-col w-5/12 mr-10 px-4 my-2">{{receiptTranslate("Signature", "receipt.signature")}}</div>
        </div>
        <div v-if="settingsStore.getValue('receipts_footer_message')"
             :dir="$ctx.receiptLanguage == 'en'? 'ltr': 'rtl'"
             class="flex items-center justify-between text-right py-2 px-4 mt-2 border-t border-gray-300 font-bold"
             style="width: 95%;" v-html="settingsStore.getValue('receipts_footer_message').replace(/\n/g, '<br>')">
        </div>
        <div v-if="settingsStore.getValue('receipts_show_brands') == 'true'" class="flex flex-row-reverse justify-between items-center w-full px-6">
          <div><img :src="Brand1" class="w-[60px] h-auto" alt=""></div>
          <div><img :src="Brand2" class="w-[60px] h-auto" alt=""></div>
          <div><img :src="Brand3" class="w-[60px] h-auto" alt=""></div>
          <div><img :src="Brand4" class="w-[60px] h-auto" alt=""></div>
          <div><img :src="Brand5" class="w-[60px] h-auto" alt=""></div>
          <div><img :src="Brand6" class="w-[60px] h-auto" alt=""></div>
          <div><img :src="Brand7" class="w-[60px] h-auto" alt=""></div>
        </div>
        <div
            v-if="settingsStore.getValue('show_receipts_thecky_footer') == 'true'"
            class="flex items-center justify-between py-4 px-4 mt-2"
            style="bottom: 0px; width: 95%; border-top: 2px solid #BDC7D6"
        >
          <p><img src="@/assets/images/thecky-qr.png" style="height: 25px;"/></p>
          <p><img src="@/assets/images/footer.svg" style="height: 25px;"/></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";

import {i18nOrderMessages, Order, OrderItem} from "@/models/sales/Order";
import {formatDate, parseFormat} from "@/utils/date";
import {useI18n} from "vue-i18n";
import {formatDinero, formatMoney} from "@/utils/money";
import {Transaction} from "@/models/accounting/Transaction";
import JsBarcode from "jsbarcode";
import {useSettingsStore} from "@/stores/settingsStore";

import Brand1 from '@/assets/images/brands/1.png';
import Brand2 from '@/assets/images/brands/2.png';
import Brand3 from '@/assets/images/brands/3.png';
import Brand4 from '@/assets/images/brands/4.png';
import Brand5 from '@/assets/images/brands/5.png';
import Brand6 from '@/assets/images/brands/6.png';
import Brand7 from '@/assets/images/brands/7.png';
import PaymentStatusReceiptRenderer from "../PaymentStatusReceiptRenderer.vue";
import { receiptPrintCSS } from "@/utils/receiptPrint";

export default defineComponent({
  components: {PaymentStatusReceiptRenderer},

  setup() {
    const {t} = useI18n({
      messages: {
        en: {
          ...i18nOrderMessages.en
        },
        ar: {
          ...i18nOrderMessages.ar,
          receipt: {
            orderType: 'نوع الطلب',
            orderTypes: {
              direct: 'مباشر',
              delivery: 'توصيل',
              pickup: 'استلام من المحل',
              quote: 'تسعيرة',
              reservation: 'حجز',
            },
            paymentTerms: 'نوع الفاتورة',
            dueOn: 'تاريخ الاستحقاق',
            invoiceTypes: {
              full: 'كامل',
              credit: 'آجل',
              layaway: 'عربون',
              cashOnDelivery: 'دفع عند التوصيل',
            },
            salesInvoice: "فاتورة بيع",
            quoteInvoice: "عرض سعر",
            quotedBy: "بواسطة",
            validUntil: "صالح حتى",
            totalItems: "عدد المنتجات",
            type: "نوع الطلب",
            direct: "مباشر",
            credit: "آجل",
            layaway: "عربون",
            customer: "الزبون",
            cashCustomer: "زبون",
            location: "المتجر",
            orderNo: "رقم الطلب",
            cashier: "موظف الكاشير",
            dateAndTime: "التاريخ والوقت",
            carrier: "شركة التوصيل",
            orderNotes: "ملاحظات الطلب",
            pouch: "رقم المحفظة",
            itemName: "اسم المنتج",
            qty: "الكمية",
            price: "السعر",
            finalPrice: "السعر النهائي",
            totalBeforeDiscounts: "المبلغ الكلي قبل التخفيض",
            totalDiscount: "المبلغ الكلي للتخفيض",
            totalShipping: "التوصيل",
            totalDue: "الاجمالي",
            customerDue: "اجمالي الزبون",
            insurance: "شركة التأمين",
            totalItemsSold: "عدد المنتجات المباعة",
            totalItemsReturned: "عدد المنتجات المسترجعة",
            totalPacksSold: 'عدد الرزم المباعة',
            transactionsInfo: "الحركات المالية",
            paymentID: "رقم الحركة",
            paymentMethod: "طريقة الدفع",
            cash: "كاش",
            changeDue: "الخردة",
            totalPaid: "المبلغ المدفوع الكلي",
            balance: "المتبقي",
            paymentNotes: "ملاحظات الحركة",
            paymentCurrencies: "عملات الحركة",
            signature: 'التوقيع',
            phone: 'رقم الهاتف',
            address: 'العنوان',
            customerCredit: 'رصيد الزبون',
            total: 'المبلغ الكلي'
          }
        }
      }
    });

    const settingsStore = useSettingsStore();

    return {
      t,
      settingsStore,
      Brand1,
      Brand2,
      Brand3,
      Brand4,
      Brand5,
      Brand6,
      Brand7,
      formatDate,
    };
  },
  props: {
    order: {
      type: Order,
      required: true
    },
    transactions: {
      type: Array as PropType<Array<Transaction>>,
      required: true
    },
    barcodeText: {
      type: String,
      required: true
    },
    isQuote: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    setTimeout(() => {
      JsBarcode("#barcode", String(this.order.externalID!.slice()), {
        height: 50,
        displayValue: false
      });
    }, 100);
  },
  created() {
    // Add print CSS when component is created
    this.addPrintCSS();
  },
  beforeUnmount() {
    // Remove print CSS when component is about to be destroyed
    this.removePrintCSS();
  },
  methods: {
    parseFormat,
    formatDinero,
    formatMoney,
    print() {
      window.print();
    },
    calculateTotalItemsSold() {
      let total = 0;
      for (const item of this.order.orderItems) {
        total += item.quantity;
      }

      return total;
    },
    calculateTotalItemsReturned() {
      let total = 0;
      for (const item of this.order.orderItems) {
        total += item.returnedQuantity;
      }
      return total;
    },
    calculateTotalItemDiscounts() {
      let total = 0;
      for (const item of this.order.orderItems) {
        total += (item.itemDiscountTotal || 0) * item.quantity;
      }
      return total;
    },
    calculateTotalBeforeDiscounts() {
      // Total before discounts = Customer Total + Total Discount
      const customerTotal = this.order.invoice?.totalDueAmount || 0;
      const totalDiscount = (this.order.invoice?.totalDiscountAmount || 0) + this.calculateTotalItemDiscounts();
      return customerTotal + totalDiscount;
    },
    addPrintCSS() {
      // Create a style element with a unique id
      const style = document.createElement("style");
      style.setAttribute("id", "print-css");
      style.textContent = receiptPrintCSS(this.$ctx.getReceiptSize());
      // Append the style to the document head
      document.head.appendChild(style);
    },
    removePrintCSS() {
      // Find and remove the style element
      const style = document.querySelector("#print-css");
      if (style && style.parentNode) {
        style.parentNode.removeChild(style);
      }
    },
    receiptTranslate(value: string, translateKey: string): string {
      return this.$ctx.receiptLanguage == "en"
          ? value
          : this.t(translateKey, this.$ctx.receiptLanguage);
    },
    getPackName(oi: OrderItem) {
      for (const ip of oi.item.itemPacks) {
        if (ip.id == oi.packInfo.itemPackID) {
          return this.$ctx.locale == 'en' ? ip.pack?.enName : ip.pack?.arName
        }
      }
    },
    orderHasPack(order: Order) {
      let has = false;
      for (const oi of order.orderItems) {
        if (oi.packInfo?.packID) {
          has = true;
          break
        }
      }
      return has;
    },
    calculateTotalPacksSold(order: Order) {
      let total = 0;
      for (const oi of order.orderItems) {
        total += oi.quantity;
      }
      return total;
    },
    calculateTotalItemsSoldV2(order: Order) {
      let total = 0;
      for (const oi of order.orderItems) {
        if (oi.packInfo?.packID) {
          total += oi.quantity * oi.packInfo?.packQuantity;
        } else {
          total += oi.quantity;
        }
      }
      return total;
    },
    calculateTotalItemsReturnedV2(order: Order) {
      let total = 0;
      for (const oi of order.orderItems) {
        if (oi.packInfo?.packID) {
          total += oi.returnedQuantity * oi.packInfo?.packQuantity;
        } else {
          total += oi.returnedQuantity;
        }
      }
      return total;
      },
      returnedOrderItems(order: Order) {
        const returnedItems: OrderItem[] = []
        for (const oi of order.orderItems) {
          if (oi.returnedQuantity > 0) {
            returnedItems.push(oi)
          }
        }
        return returnedItems
      },
      notReturnedOrderItems(order: Order) {
        const noReturnedItems: OrderItem[] = []
        for (const oi of order.orderItems) {
          if (oi.quantity > oi.returnedQuantity) {
            noReturnedItems.push(oi)
          }
        }
        return noReturnedItems
      },
      hasSpItemTag(oi: OrderItem): boolean {
        if (!oi.item?.itemTags) return false
        return oi.item.itemTags.some(tag => tag.name === 'sp.item')
      }
  }
});
</script>
<style>
.thecky-site {
  color: #000;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 3px;
}

#a4-receipt {
  width: 210mm;
  overflow: scroll;
  background-color: #fff;
}

@media print {
  body * {
    page-break-after: avoid;
    visibility: hidden;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  #a4-receipt,
  #a4-receipt * {
    visibility: visible;
  }

  #a4-receipt {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: visible;
    margin: 0cm;
  }

  #a4-receipt-header {
    top: 0;
  }

  #a4-receipt-body {
    position: relative;
  }

  p,
  div {
    page-break-inside: avoid;
  }
}

.sp-item-highlight {
  background-color: #EFB9FF !important;
}
</style>
